import React, { Component } from 'react'
import PropTypes from 'prop-types'
import moment from 'moment'
import ModeEdit from 'material-ui/svg-icons/editor/mode-edit'

import NoteEditor from './NoteEditor'
import css from './note.css'

export default class Note extends Component {

  static propTypes = {
    note: PropTypes.shape({
      id: PropTypes.number.isRequired,
      body: PropTypes.string.isRequired,
      created_at: PropTypes.string,
    }).isRequired,
    onSave: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired,
    onDelete: PropTypes.func,
    index: PropTypes.number,
  }

  state = {
    isNew: this.props.note.id === 0,
    isEditing: false,
    noteBody: this.props.note.body,
  }

  onChange = (e) => {
    this.setState({
      noteBody: e.target.value,
    })
  }

  onSave = () => {
    const { onSave, note, index } = this.props
    onSave(this.state.noteBody, note.id, index)
    .then(() => {
      if (!this.state.isNew) {
        this.toggleEdit()
      }
    })
  }

  onCancel = () => {
    this.props.onCancel()
    this.setState({
      isEditing: false,
      noteBody: this.props.note.body,
    })
  }

  onDelete = () => {
    const { onDelete, note, index } = this.props
    onDelete(note.id, index)
  }

  toggleEdit = () => {
    this.setState(prevState => ({
      isEditing: !prevState.isEditing,
    }))
  }

  render() {
    const { created_at } = this.props.note
    const { isNew, isEditing, noteBody } = this.state
    return (
      <div className={css.container}>
        {(isNew || isEditing)
        ? <NoteEditor
          value={noteBody}
          isNew={isNew}
          onChange={this.onChange}
          onSave={this.onSave}
          onCancel={this.onCancel}
          onDelete={this.onDelete}
        />
        :
          (
            <div className={css.note}>
              <div className={css.body}>{noteBody}</div>
              <div className={css.sideHover}>
                <button
                  className={css.editButton}
                  onClick={this.toggleEdit}
                >
                  <ModeEdit />
                  Edit
                </button>
                <span className={css.timestamp}>{moment(created_at).format('M/D/YY  HH:mma')}</span>
              </div>
            </div>
          )
        }
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/PatientPage/Notes/Note.js